import {
  Droplets, Building2, CloudRain, Hammer, Wind,
  Award, Shield, Wrench, Users, Target, TrendingUp, Eye,
  type LucideIcon,
} from "lucide-react";

/**
 * Shared icon registry. Posts may set `metadata.icon` to one of these keys
 * to render an associated lucide icon (services + about values, etc.).
 */
export const iconMap: Record<string, LucideIcon> = {
  Droplets,
  Building2,
  CloudRain,
  Hammer,
  Wind,
  Award,
  Shield,
  Wrench,
  Users,
  Target,
  TrendingUp,
  Eye,
};

/** Shape of the JSON `metadata` column for service-section posts. */
export type ServiceMeta = {
  icon?: keyof typeof iconMap | string;
  features?: string[];
} | null;
